export const POP_UP_TRIGGER = {
    triggers: 'mouseenter:mouseleave',
    container: 'body',
    openDelay: 100,
    closeDelay: 250,
};
